(function () {
  function initCard(card) {
    if (card.dataset.fitnCardInit) return;
    var track = card.querySelector('[data-fitn-card-track]');
    if (!track) return;

    var images = track.querySelectorAll('.fitn-col-card__img:not(.fitn-col-card__img--placeholder)');
    if (images.length <= 1) return;

    card.dataset.fitnCardInit = 'true';
    var index = 0;

    function showImage(nextIndex) {
      index = (nextIndex + images.length) % images.length;
      track.style.transform = 'translate3d(-' + index * 100 + '%, 0, 0)';
    }

    showImage(0);

    var prev = card.querySelector('[data-fitn-card-prev]');
    var next = card.querySelector('[data-fitn-card-next]');

    if (prev) {
      prev.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        showImage(index - 1);
      });
    }

    if (next) {
      next.addEventListener('click', function (event) {
        event.preventDefault();
        event.stopPropagation();
        showImage(index + 1);
      });
    }
  }

  function initCollection(root) {
    if (!root || root.dataset.fitnColInit) return;
    root.dataset.fitnColInit = 'true';

    var form = root.querySelector('form');
    var mobileWrap = root.querySelector('[data-fitn-filters-mobile]');
    var sidebar = root.querySelector('[data-fitn-filters]');
    var mobileToggle = root.querySelector('[data-fitn-mobile-filters]');

    root.querySelectorAll('[data-fitn-card]').forEach(initCard);

    function setFiltersOpen(open) {
      if (mobileWrap) mobileWrap.classList.toggle('is-open', open);
      if (sidebar) sidebar.classList.toggle('is-open', open);
      if (mobileToggle) mobileToggle.setAttribute('aria-expanded', String(open));
      if (open) {
        document.documentElement.style.overflow = 'hidden';
      } else if (
        !document.querySelector('[data-fitn-drawer].is-open') &&
        !document.getElementById('size-guide')?.classList.contains('is-open')
      ) {
        document.documentElement.style.overflow = '';
      }
    }

    function closeFilters() {
      setFiltersOpen(false);
    }

    if (mobileToggle && sidebar) {
      mobileToggle.addEventListener('click', function () {
        setFiltersOpen(!sidebar.classList.contains('is-open'));
      });

      root.querySelectorAll('[data-fitn-filters-close]').forEach(function (el) {
        el.addEventListener('click', closeFilters);
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && sidebar.classList.contains('is-open')) {
          closeFilters();
        }
      });
    }

    if (form) {
      form.querySelectorAll('[data-fitn-auto-submit]').forEach(function (el) {
        el.addEventListener('change', function () {
          form.submit();
        });
      });

      var priceReset = form.querySelector('[data-fitn-reset-price]');
      if (priceReset) {
        priceReset.addEventListener('click', function () {
          form.querySelectorAll('.fitn-col-price input').forEach(function (input) {
            input.value = '';
          });
          form.submit();
        });
      }
    }

    initEditorialInfinite(root);
  }

  function initEditorialInfinite(root) {
    var grid = root.querySelector('[data-fitn-editorial-grid]');
    if (!grid) return;

    var loading = false;

    function nextUrl() {
      return grid.getAttribute('data-next-url') || '';
    }

    function loadMore() {
      var url = nextUrl();
      if (!url || loading) return;
      loading = true;
      grid.setAttribute('aria-busy', 'true');

      fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) throw new Error('Failed to load more products');
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var nextGrid = doc.querySelector('[data-fitn-editorial-grid]');
          if (!nextGrid) {
            grid.removeAttribute('data-next-url');
            return;
          }

          var fragment = document.createDocumentFragment();
          Array.prototype.forEach.call(nextGrid.children, function (child) {
            fragment.appendChild(document.importNode(child, true));
          });
          grid.appendChild(fragment);
          grid.querySelectorAll('[data-fitn-card]').forEach(initCard);

          var more = nextGrid.getAttribute('data-next-url');
          if (more) {
            grid.setAttribute('data-next-url', more);
          } else {
            grid.removeAttribute('data-next-url');
          }
        })
        .catch(function () {
          grid.removeAttribute('data-next-url');
        })
        .finally(function () {
          loading = false;
          grid.removeAttribute('aria-busy');
        });
    }

    function onScroll() {
      if (!nextUrl() || loading) return;
      var rect = grid.getBoundingClientRect();
      if (rect.bottom <= window.innerHeight + 800) {
        loadMore();
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function initLookbookMode() {
    if (!document.documentElement.classList.contains('fitn-collection--lookbook')) return;

    document.querySelectorAll('.fitn-lookbook__pagination a').forEach(function (link) {
      var url = new URL(link.href, window.location.origin);
      url.searchParams.set('lookbook', '1');
      link.href = url.toString();
    });
  }

  document.querySelectorAll('.fitn-col').forEach(initCollection);
  initLookbookMode();
})();
